import { createContext, useContext } from 'react';
import { MongoAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';

// Define the ability type for strong typing
type AppAbility = MongoAbility<[string, string]>;

// Create the context with a default value (null or an instance of MongoAbility)
export const AbilityContext = createContext<AppAbility | null>(null);

// Create the Can component for CASL integration
export const Can = createContextualCan(AbilityContext.Consumer);
export const useAbilityContext = () => useContext(AbilityContext);

// Example: Initialize an ability instance (optional, for demonstration)
// const ability = createMongoAbility<[string, string]>([
//   { action: 'read', subject: 'Article' },
// ]);
